import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvBannerComponent } from '@rind/ui';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, EnvBannerComponent],
  template: `
    <rind-env-banner [name]="envName" />
    <section class="app-container">
      <router-outlet />
    </section>
  `,
  styles: `
    :host {
      display: grid;
      grid-template-areas:
        'banner'
        'app';
      grid-template-rows: auto 1fr;
      height: 100%;
      width: 100%;
      overflow: hidden;
    }

    rind-env-banner {
      grid-area: banner;
    }

    .app-container {
      grid-area: app;
      min-height: 0;
      overflow: hidden;
      height: 100%;
    }
  `,
})
export class App {
  protected readonly envName = environment.name;
}
